import { useEffect, useState } from 'react';
import {
  Alert,
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  List,
  ListItem,
  ListItemText,
  Typography
} from '@mui/material';
import { LoadingButton } from '@mui/lab';

const DeleteCompanyModal = ({ open, onClose, onDelete, company, deletionPlan, loadingPlan }) => {
  const [confirmed, setConfirmed] = useState(false);
  const [deleting, setDeleting] = useState(false);

  useEffect(() => {
    if (open) {
      setConfirmed(false);
      setDeleting(false);
    }
  }, [open, company?.id]);

  const handleDelete = async () => {
    if (!company || !confirmed) return;

    setDeleting(true);
    try {
      await onDelete(company);
    } finally {
      setDeleting(false);
    }
  };

  const items = deletionPlan?.items || [];

  return (
    <Dialog open={open} onClose={deleting ? undefined : onClose} fullWidth maxWidth="sm">
      <DialogTitle>Eliminar empresa</DialogTitle>
      <DialogContent>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
          <Alert severity="warning">
            Esta acción elimina la empresa y sus recursos provisionados. No se puede deshacer.
          </Alert>

          <Box>
            <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
              {company?.name || 'Empresa'}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Dominio de login: {company?.domain || '-'}
            </Typography>
          </Box>

          <Box>
            <Typography variant="subtitle2" sx={{ mb: 1 }}>
              Se va a eliminar:
            </Typography>
            {loadingPlan ? (
              <Typography variant="body2" color="text.secondary">
                Cargando recursos...
              </Typography>
            ) : (
              <List dense sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 1 }}>
                {items.map((item) => (
                  <ListItem key={`${item.label}-${item.value}`} divider>
                    <ListItemText
                      primary={item.label}
                      secondary={item.value}
                      primaryTypographyProps={{ fontWeight: 600 }}
                    />
                  </ListItem>
                ))}
              </List>
            )}
          </Box>

          <FormControlLabel
            control={
              <Checkbox
                checked={confirmed}
                onChange={(event) => setConfirmed(event.target.checked)}
                disabled={loadingPlan || deleting}
              />
            }
            label="Entiendo que se eliminarán todos estos recursos permanentemente."
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={deleting}>
          Cancelar
        </Button>
        <LoadingButton
          color="error"
          variant="contained"
          loading={deleting}
          disabled={!confirmed || loadingPlan || items.length === 0}
          onClick={handleDelete}
        >
          Eliminar
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteCompanyModal;
